
// PATHS
import axios from "axios";

const SEARCH_DMS = '/network/ms/search';
const UPDATE_GENERAL_INFO_DMS = '/network/ms/update';
const UPDATE_ADDITIONAL_INFO_DMS = '/network/additionalInfo/update';
const UPDATE_PROPOSAL_INFO_DMS = '/network/ms/proposalInfo/update';
const UPDATE_REPRESENTATIVE_INFO_DMS = '/network/representativeInfo/update';
const UPDATE_FINANCIAL_INFO_DMS = '/network/financialInfo/update';
const UPDATE_POS_INFO_DMS = '/network/posInfo/update';
const UPDATE_ASSOCIATION_INFO_DMS = '';
const UPDATE_EPARKING_INFO_DMS = '/network/eParking/update';
const GET_DMS_BY_ID = '/network/ms-application/findMobilityStoreById';
const GET_DMS_BY_SAP_ID = '/network/ms/v1/get-areas-keyless-bysapid';
const INSERT_DOCUMENTS_DMS = '/network/documents/ms';
const EXPORT_DMS = '/network/ms/export';

const UPDATE_KEYLESS_INFO = '/network/ms/v1/keylessInfo/update';
const UPDATE_KEYLESS_OPERATION_AREA = '/network/ms/v1/save-area-keyless';
const UPDATE_KEYLESS_INFO_FULL = '/network/ms/v1/keylessInfo/updatefull';

const search: any = async (req: any) => {
    const response = await axios.post(SEARCH_DMS, req);
    return response.data;
}

const updateGeneralInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_GENERAL_INFO_DMS, req);
    return response.data;
}

const updateAdditionalInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_ADDITIONAL_INFO_DMS, req);
    return response.data;
}

const updateProposalInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_PROPOSAL_INFO_DMS, req);
    return response.data;
}

const updateEparkingInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_EPARKING_INFO_DMS, req);
    return response.data;
}

const updateRepresentativeInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_REPRESENTATIVE_INFO_DMS, req);
    return response.data;
}

const updateFinancialInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_FINANCIAL_INFO_DMS, req);
    return response.data;
}

const updatePosInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_POS_INFO_DMS, req);
    return response.data;
}

const updateAssociationInfo: any = async (req: any) => {
    const response = await axios.post(UPDATE_ASSOCIATION_INFO_DMS, req);
    return response.data;
}

const updateKeylessInfo: any = async (req: any) => {
    console.log('updateKeylessInfo request: ' + JSON.stringify(req) );
    const response = await axios.post(UPDATE_KEYLESS_INFO, req);
    console.log('updateKeylessInfo response: ' + JSON.stringify(response) );
    return response.data;
}

const updateKeylessOperationArea: any = async (req: any) => {
    console.log('updateKeylessOperationArea request: ' + JSON.stringify(req) );
    const response = await axios.post(UPDATE_KEYLESS_OPERATION_AREA, req);
    console.log('updateKeylessOperationArea response: ' + JSON.stringify(response) );
    return response.data;
}

const createKeylessInfoAndArea: any = async (req: any) => {
    console.log('createKeylessInfoAndArea request: ' + JSON.stringify(req) );
    const response = await axios.post(UPDATE_KEYLESS_INFO_FULL, req);
    console.log('createKeylessInfoAndArea response: ' + JSON.stringify(response.data) );
    return response.data;
}

const getMobilityStoreById: any = async (req:any) => {
    const response = await axios.post(GET_DMS_BY_ID, req);
    // console.log('getMobilityStoreById : ' + JSON.stringify(response.data.mobilityStore) );
    // console.log('getMobilityStoreById keylessInfo: ' + JSON.stringify(response.data.mobilityStore.keylessInfo) );
    // console.log('getMobilityStoreById keylessArea: ' + JSON.stringify(response.data.mobilityStore.keylessArea) );
    return response.data;
}

const getMobilityStoreBySapId = async (id: string) => {
    const response = await axios.get(`${GET_DMS_BY_SAP_ID}/${id}`);
    // console.log('getMobilityStoreById : ' + JSON.stringify(response.data.mobilityStore) );
    // console.log('getMobilityStoreById keylessInfo: ' + JSON.stringify(response.data.mobilityStore.keylessInfo) );
    // console.log('getMobilityStoreById keylessArea: ' + JSON.stringify(response.data.mobilityStore.keylessArea) );
    return response.data;
}

const insertDocumentDms: any = async (req:any) => {
    const response = await axios.post(INSERT_DOCUMENTS_DMS, req);
    return response.data;
}

const exportDMS: any = async (req: any) => {
    return new Promise(function (resolve, reject) {
        axios.post(EXPORT_DMS, req, {
            responseType: 'arraybuffer',
            headers: { 'Access-Control-Allow-Origin': true }
        }
        ).then(function (response) {
            resolve(response);
        }).catch(function (error) {
            reject(error)
        })
    });
}


export {
    search,
    updateGeneralInfo,
    updateAdditionalInfo,
    updateProposalInfo,
    updateRepresentativeInfo,
    updateFinancialInfo,
    updatePosInfo,
    updateAssociationInfo,
    updateEparkingInfo,
    updateKeylessInfo,
    updateKeylessOperationArea,
    createKeylessInfoAndArea,
    getMobilityStoreById,
    getMobilityStoreBySapId,
    insertDocumentDms,
    exportDMS
}